module.exports = __webpack_public_path__ + "assets/pictograms/professional-user.40872492d14714de4abdd64875fee345.svg";